import { render } from "./espacos.vue?vue&type=template&id=9140727c&scoped=true"
import script from "./espacos.vue?vue&type=script&lang=js"
export * from "./espacos.vue?vue&type=script&lang=js"

import "./espacos.vue?vue&type=style&index=0&id=9140727c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9140727c"]])

export default __exports__